<app-name-details-form [initialData]="initialData" testIdPrefix="wizard-name-"></app-name-details-form>
